import React, { useState, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';

import CircularProgress from '@material-ui/core/CircularProgress';
import MapComponent from '~/components/MapComponent';
import Backdrop from '~/components/BackdropComponent';
import { errorMessage } from '~/utils/Message';

import { Container } from '../Patient/styles';

import api from '~/services/api';

function Blood() {
  const profile = useSelector((state) => state.user.profile);
  const hemocenter_id = profile.hemocenter ? profile.hemocenter.id : undefined;

  const [markers, setMarkers] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.title = 'Mapa de sangramentos | ClickHemofilia';
  }, []);

  const loadBloods = useCallback(async () => {
    setLoading(true);

    try {
      const { data } = await api.get('/geolocation/bloods', {
        params: {
          hemocenter_id,
        },
      });

      setMarkers(data);
    } catch (error) {
      errorMessage(error);
    } finally {
      setLoading(false);
    }
  }, [hemocenter_id]);

  useEffect(() => {
    loadBloods();
  }, [loadBloods]);

  return (
    <Container>
      <MapComponent markers={markers} />

      <Backdrop open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Container>
  );
}

export default Blood;
